var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"promotion-page container"},[_c('SimpleBreadcrumbs',{staticClass:"app--desktop",attrs:{"links":[
            {
                name: 'Головна сторінка',
                href: '/'
            },
            {
                name: 'Унікальні пропозиції',
                href: `/uk/promotions`
            },
            {
                name: _vm.currentPromotion.title,
                href: `/uk/promotions/${ _vm.$route.params.id }`
            },
        ]}}),(_vm.currentPromotion)?_c('div',{staticClass:"promotion-page__banner"},[_c('img',{attrs:{"src":_vm.currentPromotion.bannerImage,"alt":""}}),_c('div',{staticClass:"promotion-page__banner--info"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.currentPromotion.title))]),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.currentPromotion.description)}}),(_vm.formattedTimeRemaining)?_c('span',{staticClass:"timer"},[_vm._v("До закінчення акції залишилось "),_c('br',{staticClass:"app--mobile"}),_vm._v(" "+_vm._s(_vm.formattedTimeRemaining))]):_vm._e()])]):_vm._e(),_c('div',{staticClass:"promotion-page__products"},_vm._l((_vm.products),function(product){return _c('Product',{attrs:{"product":product}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }